import { BillingAddress, CompanyInfo, InvoiceMethod } from '../generic/info'

export interface Customer {
  customerId: number
  billingAddress: BillingAddress
  companyInfo: CompanyInfo
  invoiceMethod: InvoiceMethod
}

export interface CustomerContact {
  contactId: number
  customerId: number
  firstName: string
  lastName: string
  emailAddress: string
  mobilePhone: string
  fixedPhone: string
  languageId: number
  language: string
}

export interface LeaderboardItem {
  id: number
  msisdn: string
  firstName: string
  lastName: string
  label: string
  volume: number
  cost: number
}

export interface CustomerSelector {
  customerId: string
  relationContactId: string
  system: string
}

export const isCustomer = (customer: any): customer is Customer => {
  if (customer === undefined) {
    return false
  }
  return 'customerId' in customer && !('UsageType' in customer)
}
export const isBillingAddress = (address: any): address is BillingAddress => {
  if (address === undefined) {
    return false
  }
  return 'postalCode' in address && 'companyName' in address
}
export const isInvoiceMethod = (method: any): method is InvoiceMethod => {
  if (method === undefined) {
    return false
  }
  return 'emailAddress' in method && 'post' in method && 'peppol' in method && 'peppolId' in method
}

export const isLeaderboardItem = (leaderboardItem: any): leaderboardItem is LeaderboardItem => {
  if (leaderboardItem === undefined) {
    return false
  }
  if (leaderboardItem.volume === undefined) {
    return false
  }
  return true
}
